export default __webpack_public_path__ + "static/media/01_2_project-members.f6b8bc93.png";